<template>
  <div class="faq-page">
    <b-card class="faq-card">
      <div class="faq-header text-center">
        <h2>FAQ’s</h2>
        <p>Let us help answer the most common questions.</p>
      </div>

      <div class="faq-list">
        <div
          v-for="(item, index) in faqItems"
          :key="index"
          class="faq-item"
          :class="{ 'faq-item--active': activeIndex === index }"
          @click="toggle(index)"
        >
          <h5 class="faq-question mb-0">{{ item.question }}</h5>
          <p v-if="activeIndex === index" class="faq-answer mb-0">
            {{ item.answer }}
          </p>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import { BCard } from 'bootstrap-vue'

export default {
  components: {
    BCard,
  },
  data() {
    return {
      activeIndex: 1,
      faqItems: [
        {
          question: 'How do you process payments?',
          answer:
            'We accept secure online payments and process all transactions instantly through verified payment gateways.',
        },
        {
          question: 'What counts towards the 100 responses limit?',
          answer:
            "We count all responses submitted through all your forms in a month. If you already received 100 responses this month, you won't be able to receive any more of them until next month when the counter resets.",
        },
        {
          question: 'What payment methods do you accept?',
          answer:
            'We support cards, UPI, and selected wallet options depending on your region.',
        },
      ],
    }
  },
  methods: {
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? -1 : index
    },
  },
}
</script>

<style scoped>
.faq-card {
  border: 1px solid #ebe9f1;
  min-height: 560px;
  padding: 2.5rem 2rem;
}

.faq-header h2 {
  font-size: 2.25rem;
  font-weight: 600;
  color: #4b465c;
}

.faq-header p {
  color: #6e6b7b;
  font-size: 0.95rem;
  margin-top: 0.6rem;
  margin-bottom: 2rem;
}

.faq-list {
  max-width: 900px;
  margin: 0 auto;
}

.faq-item {
  background: #fff;
  border: 1px solid #ebe9f1;
  border-radius: 6px;
  padding: 1rem 1.1rem;
  margin-bottom: 0.6rem;
  cursor: pointer;
}

.faq-item--active {
  box-shadow: 0 2px 10px rgba(47, 43, 61, 0.08);
}

.faq-question {
  font-size: 1rem;
  color: #4b465c;
}

.faq-answer {
  color: #6e6b7b;
  margin-top: 0.8rem;
  line-height: 1.6;
}
</style>